var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('em',{staticClass:"title"},[_vm._v("快速选择时间")]),_vm._l((_vm.titleArr),function(tit,index){return _c('span',{key:index,class:{'active':index == (_vm.tab - 2)},on:{"click":function($event){return _vm.change(index)}}},[_vm._v(_vm._s(tit.title))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }